module.exports = __webpack_public_path__ + "static/logocowork-fcaa216f717d91e8228283985b2e7353.png";